import Ajax from './Ajax.js'

const IsoResponsible = {
  getIsoResponsibles: (id = null) => {
    let uri = id !== null
      ? '/iso-responsibles' + '/' + id
      : '/iso-responsibles'
    return Ajax.get(uri)
  },

  postIsoResponsibles: (params) => {
    const payload = params && params.data ? params : {
      data: {
        area: params.area,
        roleType: params.roleType || params.role_type,
        fullName: params.fullName || params.full_name,
        taxId: params.taxId || params.tax_id,
        phone: params.phone,
        email: params.email,
        mandateDocument: params.mandateDocument || params.mandate_document,
        auditorStatus: params.auditorStatus || params.auditor_status
      }
    }
    return Ajax.post('/iso-responsibles', payload)
  },

  putIsoResponsibles: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/iso-responsibles/' + id, payload)
  }
}

export default IsoResponsible
